"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconOthersFilled = _interopRequireDefault(require("../Icons/IconOthersFilled"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledSubmenuItem = function StyledSubmenuItem(_ref) {
  var label = _ref.label,
      type = _ref.type,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement(SubMenuItem, {
    onClick: onClick,
    className: type
  }, label);
};

StyledSubmenuItem.propTypes = {
  /** The text to be displayed in the menu item. */
  label: _propTypes.string,

  /** The type of menu item, used for styling. */
  type: _propTypes.string,

  /** A onClick function to be executed when the item is clicked. */
  onClick: _propTypes.func.isRequired
};
StyledSubmenuItem.defaultProps = {
  onClick: function onClick() {},
  type: ''
};

var QuickActionSubMenu = function QuickActionSubMenu(_ref2) {
  var children = _ref2.children,
      otherProps = _objectWithoutProperties(_ref2, ["children"]);

  var node = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuOpen = _useState2[0],
      setMenuOpen = _useState2[1];

  (0, _react.useEffect)(function () {
    if (menuOpen) {
      document.body.addEventListener('click', handleClick);
    } else {
      document.body.removeEventListener('click', handleClick);
    }

    return function () {
      document.body.removeEventListener('click', handleClick);
    };
  }, [menuOpen]);

  var handleClick = function handleClick(e) {
    if (node.current.contains(e.target)) {
      return;
    }

    setMenuOpen(false);
  };

  var handleInsideClick = function handleInsideClick(e) {
    e.stopPropagation();
    setMenuOpen(false);
  };

  return /*#__PURE__*/_react.default.createElement(QuickActionSubMenuWrapper, _extends({}, otherProps, {
    ref: node
  }), /*#__PURE__*/_react.default.createElement(MenuToggle, {
    onClick: function onClick() {
      return setMenuOpen(!menuOpen);
    }
  }, /*#__PURE__*/_react.default.createElement(_IconOthersFilled.default, null)), /*#__PURE__*/_react.default.createElement(SubMenu, {
    open: menuOpen,
    onClick: handleInsideClick
  }, children));
};

var QuickActionSubMenuWrapper = _styledComponents.default.div.withConfig({
  displayName: "QuickActionSubMenuWrapper"
})(["position:relative;font-family:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.font;
});

var MenuToggle = _styledComponents.default.a.withConfig({
  displayName: "MenuToggle"
})(["cursor:pointer;svg > circle{fill:", ";}&:hover{svg > circle{fill:", ";}}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.typo.title;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.brand.primary;
});

var SubMenu = _styledComponents.default.div.withConfig({
  displayName: "SubMenu"
})(["width:125px;position:absolute;display:", ";background-color:white;flex-direction:column;top:30px;overflow:hidden;border-radius:5px;border:1px solid #e6e6e6;transform:translateX(calc(-50% + 18px));box-shadow:1px 2px 5px rgba(0,0,0,0.1);z-index:9999;"], function (_ref6) {
  var open = _ref6.open;
  return open ? 'flex' : 'none';
});

var SubMenuItem = _styledComponents.default.a.withConfig({
  displayName: "SubMenuItem"
})(["padding:5px 10px;display:block;width:100%;cursor:pointer;font-size:1.2rem;line-height:120%;transition:background-color 0.15s ease-in-out;&:hover{background-color:", ";}&.danger{color:", ";}&.warning{color:", ";}&.success{color:", ";}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.ui.toolbar;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.status.error;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.status.warning;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.status.succes;
});

QuickActionSubMenu.propTypes = {
  /** Menu items passed as children. */
  children: _propTypes.node.isRequired,
  otherProps: _propTypes.object
};
QuickActionSubMenu.defaultProps = {
  otherProps: {}
};
QuickActionSubMenu.SubMenuItem = StyledSubmenuItem;
QuickActionSubMenu.SubMenuItem.displayName = 'QuickActionSubMenu.SubMenuItem';
var _default = QuickActionSubMenu;
exports.default = _default;